import React from "react";

export const Spinner = () => {
  return <div className="loader">Loading ...</div>;
};
